function initPrevButton() {
	const prevButtons = document.querySelectorAll( '[data-prev-button]' );

	if ( prevButtons.length ) {
		[...prevButtons].forEach( ( element ) => {
			element.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				history.back();
			} );
		} );
	}
}

export default {
	init() {
		initPrevButton();
	},
};